export enum FilterCheckboxState {
    notChecked = 0,
    indeterminate = 1,
    checked = 2
}
